import actionWebInvoke from './actionCallUtils';
import actions from '../config.json';
import OBJCODE from '../constants';

const fetchCustomFormFields = async element => {
  const queryParams = {
    ID: element?.category?.ID,
  };
  const fields = [
    'categoryParameters:displayOrder',
    'categoryParameters:parameter:name',
    'categoryParameters:parameter:dataType',
    'categoryParameters:parameter:displayType',
    'categoryParameters:parameter:description',
    'categoryParameters:isRequired',
    'categoryParameters:parameter:label',
    'categoryParameters:parameter:parameterOptions:label',
    'categoryParameters:parameter:parameterOptions:value',
    'categoryCascadeRules:nextParameterID',
    'categoryCascadeRules:otherwiseParameterID',
    'categoryCascadeRules:ruleType',
    'categoryCascadeRules:toEndOfForm',
    'categoryCascadeRules:categoryCascadeRuleMatches:parameterID',
    'categoryCascadeRules:categoryCascadeRuleMatches:value',
  ];
  const categoryRes = await actionWebInvoke(
    actions['workfront-action'],
    {},
    { objCode: OBJCODE.CTGY_SEARCH, queryParams, fields },
  );
  return categoryRes;
};

const filterRequiredFields = data => {
  // filter isRequired field
  const filteredData = data.filter(element => element.isRequired === true);
  return filteredData;
};

const filterFieldsBasedOnCascadeRules = (
  rules,
  filteredCategoryParameters,
  finalCategoryParams, // array with all the filtered is required field without cascade rules
) => {
  filteredCategoryParameters.forEach(elementOne => {
    const validateCondition = rules.some(element => {
      return (
        element.categoryCascadeRuleMatches[0].parameterID ===
          elementOne.parameter.ID ||
        element.nextParameterID === elementOne.parameter.ID
      );
    });
    if (!validateCondition) {
      finalCategoryParams.push(elementOne);
    }
  });
};

const fetchCustomFormsAndFields = async (categories, isRequest) => {
  if (categories[0]?.objectCategories.length) {
    const requests = categories[0]?.objectCategories.map(element =>
      fetchCustomFormFields(element),
    );
    const result = await Promise.all(requests);
    const finalCategoryParams = [];
    result.flat().forEach(({ categoryParameters, categoryCascadeRules }) => {
      const filteredCategoryParameters = isRequest
        ? categoryParameters
        : filterRequiredFields(categoryParameters);

      if (categoryCascadeRules.length > 0) {
        filterFieldsBasedOnCascadeRules(
          // check whether cascade rule matches paramId is not equal to categoryParameter paramId
          categoryCascadeRules,
          filteredCategoryParameters,
          finalCategoryParams,
        );
      } else {
        // push the data one by one if isRequired is true but no cascade rule applied
        filteredCategoryParameters.forEach(element => {
          finalCategoryParams.push(element);
        });
      }
    });
    return finalCategoryParams;
  }
  return [];
};

export default fetchCustomFormsAndFields;
